'use client'
import TripatraLogo from '@assets/svg/tripatra_logo_header.svg';
import { useAuthGuard } from '@store/authstore';
import { ALLOWED_PUBLIC_PATHS, AUTH_PATHS, DEFAULT_NAVIGATION_AUTHORIZED_INTERNAL, DEFAULT_NAVIGATION_AUTHORIZED_VENDOR, DEFAULT_NAVIGATION_UNAUTHORIZED } from 'consts/navigation';
import Image from "next/image";
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated, hydrated, user } = useAuthGuard();
    const router = useRouter();

    const pathname = usePathname();
    const normalizePath = (path: string) => path.replace(/\/$/, "");
    const isPublicPath = (path: string) => ALLOWED_PUBLIC_PATHS.some(allowed => normalizePath(allowed) === normalizePath(path));
    const isAuthPath = (path: string) => AUTH_PATHS.some(allowed => normalizePath(allowed) === normalizePath(path));

    useEffect(() => {
        //  if its not authenticated and its not public path, redirect to login
        if (hydrated && !isAuthenticated && !isPublicPath(pathname)) {
            router.push(DEFAULT_NAVIGATION_UNAUTHORIZED);
        }
        // if its authenticated and its auth path, redirect to dashboard
        if (hydrated && isAuthenticated && isAuthPath(pathname)) {
            if (user?.type_user?.toLocaleLowerCase() === 'internal') {
                router.push(DEFAULT_NAVIGATION_AUTHORIZED_INTERNAL);
            } else {
                router.push(DEFAULT_NAVIGATION_AUTHORIZED_VENDOR);
            }
        }
    }, [hydrated, isAuthenticated, router]);


    if (!hydrated) {
        return <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="flex flex-col">
                <div className="m-auto mb-4">
                    <Image src={TripatraLogo} alt="logo" width={400} height={400} />
                </div>
                <p className="text-center text-gray-700">
                    Please wait.. if you are not redirected to login page, <a href="/auth/login" className="text-blue-500 underline">click here</a>
                </p>
            </div>
        </div>
    }

    return <>{children}</>;
};

export default AuthGuard;
